/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  DragDropProvider,
  Grid,
  Table,
  TableColumnResizing,
  TableEditColumn,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { accountFormatter, currencyFormatter } from './colorFormat';
import { CommandSmall } from './CommandSmall';
import { getColumns } from '../common/columns';
import { useTemplate } from '../hooks';
import PopupEditing from './PopupEditing';
import PopupKaidItem from '../pubups/PopupKaidItem';

export const getRowId = (row: any) => row.index;

const NumberTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function KaidsSingleTable({
  rows,
  removeItem,
  isRTL,
  words,
  accounts,
  editItem,
  user,
  departments,
  employees,
  resourses,
  contracts,
  customers,
  suppliers,
}: any) {
  const col = getColumns({ isRTL, words });

  const { tempoptions } = useTemplate();
  const [columns] = useState(
    [
      { name: 'index', title: words.no },
      { name: 'acc', title: words.account },
      { name: 'oppacc', title: isRTL ? 'الحساب المقابل' : 'Opposite Account' },
      { name: 'amountDebit', title: words.amountDebit },
      { name: 'amountCredit', title: words.amountCredit },
      { name: 'desc', title: words.description },
      tempoptions?.contract && col.contract,
      col.employee,
      col.department,
      col.customer,
      col.supplier,
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 70, align: 'left' },
    { columnName: 'acc', width: 150 },
    { columnName: 'oppacc', width: 150 },
    { columnName: 'amountDebit', width: 100, align: 'left' },
    { columnName: 'amountCredit', width: 100, align: 'left' },
    { columnName: 'desc', width: 250 },
    { columnName: col.contract.name, width: 180, align: 'left' },
    { columnName: col.employee.name, width: 180, align: 'left' },
    { columnName: col.department.name, width: 180, align: 'left' },
    { columnName: col.customer.name, width: 180, align: 'left' },
    { columnName: col.supplier.name, width: 180, align: 'left' },
  ]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const index = deleted[0];
      removeItem(index);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };
  return (
    <Paper
      style={{
        maxHeight: 265,
        overflow: 'auto',
        margin: 10,
        minHeight: 265,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />
          <DragDropProvider />

          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
            messages={{
              noData: isRTL ? 'لا يوجد بيانات' : 'no data',
            }}
            rowComponent={(props: any) => (
              <Table.Row {...props} style={{ height: 40 }}></Table.Row>
            )}
          />
          <DataTypeProvider
            for={['amount', 'amountDebit', 'amountCredit']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <NumberTypeProvider for={['index']} />
          <DataTypeProvider
            for={['acc', 'oppacc']}
            formatterComponent={(props) =>
              accountFormatter(props, accounts, isRTL)
            }
          ></DataTypeProvider>
          <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
          <TableEditColumn
            showDeleteCommand
            showEditCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <PopupEditing editAction={editItem}>
            <PopupKaidItem
              isRTL={isRTL}
              words={words}
              accounts={accounts}
              departments={departments}
              employees={employees}
              resourses={resourses}
              contracts={contracts}
              customers={customers}
              suppliers={suppliers}
              acustomer={true}
              asupplier={true}
              acontract={true}
              aresourse={true}
              aemployee={true}
              adepartment={true}
              user={user}
            ></PopupKaidItem>
          </PopupEditing>
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
